// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainRelatiesSoortRelatieEnum =
  (typeof SUREbusinessCommonDomainRelatiesSoortRelatieEnum)[keyof typeof SUREbusinessCommonDomainRelatiesSoortRelatieEnum];

export const SUREbusinessCommonDomainRelatiesSoortRelatieEnum = {
  Z: 'Z',
  P: 'P',
} as const;
